import { render, staticRenderFns } from "./UpdateNumberOfBoxes.vue?vue&type=template&id=7237fbe2"
import script from "./UpdateNumberOfBoxes.vue?vue&type=script&lang=js"
export * from "./UpdateNumberOfBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports